import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactRouter from "./Config/React-Router";

function App() {
  return <ReactRouter />

}

export default App;
